<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">Archive Organization</v-card-title>

    <v-card-text>
        <v-checkbox
                label="Archiving an organization will mark it for deletion (90 days). Additionally, users for the organization won't be able to login."
                v-model="archived_checked"
                dense
            />

        <v-spacer></v-spacer>
        <v-textarea v-if="archived_checked" label="Notes" v-model="archived_notes">
        </v-textarea>
        
    </v-card-text>
    <v-card-subtitle v-if="archivedDateNotEmpty()">Archived Date: {{archived_date_pretty}}</v-card-subtitle>
    <v-card-subtitle v-if="archivedByNotEmpty()">Archived By: {{employee_archived_by_label}}</v-card-subtitle>

    <v-card-actions>
        <v-btn
            v-if="can_delete_organization"
            color="black darken-1"
            text
            @click="onDeleteOrganization"
        >
        Delete Organization
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="onCancel"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>

</v-dialog>
</template>

<script>

export default {
    data() {
        return {
            dialog: false,
            archived_checked: false,
            can_delete_organization: false,
            on_success: null,

            organization_id: '',

            archived_notes: '',
            employee_id_archived_by: '',
            archived_date: '',


            show_loading: false,
        }
    },

    methods: 
    {
        archivedByNotEmpty()
        {
            if (this.employee_archived_by_label != null && this.employee_archived_by_label != '') return true;

            return false;
        },

        archivedDateNotEmpty()
        {
            if (this.archived_date_pretty != null && this.archived_date_pretty != '') return true;

            return false;
        },

        showDialog(response_data, on_success)
        {
            this.dialog = true;
            this.show_loading = true;
            this.on_success = on_success;
            this.employee_archived_by_label = response_data.organization_archived_by_label;

            this.archived_date_pretty = response_data.organization_archived_date_pretty;

            if (response_data.archived_info)
            {
                this.archived_checked = true;
                this.archived_notes = response_data.archived_info.notes;
                this.archived_date = response_data.archived_info.archived_date;
                this.employee_id_archived_by = response_data.archived_info.employee_id_archived_by;
            }
            else
            {
                this.resetData();
            }

            this.organization_id = response_data.organization_id;
            this.can_delete_organization = response_data.can_delete_organization;
        },

        resetData()
        {
            this.archived_checked = false;
            this.can_delete_organization = false;
            this.archived_notes = '';
            this.organization_id = '';
            this.employee_id_archived_by = '';
            this.employee_archived_by_label = '';
            this.archived_date = '';
            this.archived_date_pretty = '';
        },

        onCancel()
        {
            this.dialog = false;
            this.show_loading = false;

            this.resetData();
        },

        onDeleteOrganization()
        {
            this.$rc.confirm(
                "Delete Organization",
                "This will permanently delete the organization.",
                [
                    {'text' : 'Cancel', 'value' : 'cancel' },
                    {'text' : 'OK', 'value' : 'confirmed' },
                ],

                (response) => {
                    if ( response != 'confirmed' ) return;

                    this.$rc.deleteOrganizationAccount(this.organization_id, this.on_success);
                    this.onCancel();
                }
            );
        },

        onOk()
        {
           this.dialog = false;
         
           let archived_info =
           {
              "archived_date": this.archived_date,
              "employee_id_archived_by": this.employee_id_archived_by,
              "notes": this.archived_notes
           };

            let ret = 
            {
                "archived_checked": this.archived_checked,
                "organization_id": this.organization_id,
                "archived_info": archived_info
            };

            this.$rc.onPutArchiveOrganizationInfo(ret, this.on_success);
        }
    },
}
</script>

<style lang="scss" scoped>

</style>